import { render, staticRenderFns } from "./RecJobList.vue?vue&type=template&id=4872d0f4&scoped=true"
import script from "./RecJobList.vue?vue&type=script&lang=js"
export * from "./RecJobList.vue?vue&type=script&lang=js"
import style0 from "./RecJobList.vue?vue&type=style&index=0&id=4872d0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872d0f4",
  null
  
)

export default component.exports